
import moment from 'moment';

export const generateDate = (start_date, end_date) => {
    start_date = moment(start_date, "YYYY-MM-DD");
    end_date = moment(end_date,'YYYY-MM-DD');
    var dates = getDates(start_date, end_date);
    dates = dates.map((val) => {
        return {
            choose:false,
            date:val
        };
    });
    return dates;
}

function getDates(startDate, stopDate) {
    var dateArray = [];
    var currentDate = moment(startDate);
    stopDate = moment(stopDate);
    while (currentDate <= stopDate) {
        dateArray.push(moment(currentDate).format('YYYY-MM-DD'))
        currentDate = moment(currentDate).add(1, 'days');
    }
    return dateArray;
}